"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("../Themes/styled-components"));
var FormGroupContext_1 = __importDefault(require("../FormGroup/FormGroupContext"));
var Textarea = styled_components_1.default('textarea')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  width: 100%;\n  border-radius: ", ";\n  ", "\n  font-size: ", ";\n  padding: ", ";\n  color: ", ";\n  font-family: ", ";\n  outline: 0;\n  &::placeholder {\n    color: ", ";\n  }\n  ", ";\n  &:focus {\n    border-color: ", ";\n  }\n  &:disabled {\n    -webkit-text-fill-color: ", ";\n    background-color: ", ";\n    cursor: ", ";\n  }\n"], ["\n  ",
    "\n  width: 100%;\n  border-radius: ", ";\n  ",
    "\n  font-size: ", ";\n  padding: ", ";\n  color: ", ";\n  font-family: ", ";\n  outline: 0;\n  &::placeholder {\n    color: ", ";\n  }\n  ",
    ";\n  &:focus {\n    border-color: ", ";\n  }\n  &:disabled {\n    -webkit-text-fill-color: ", ";\n    background-color: ", ";\n    cursor: ", ";\n  }\n"])), function (_a) {
    var resizable = _a.resizable;
    return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    resize: ", ";\n  "], ["\n    resize: ", ";\n  "])), resizable ? 'vertical' : 'none');
}, function (_a) {
    var theme = _a.theme;
    return theme.largeBorderRadius;
}, function (_a) {
    var theme = _a.theme, error = _a.error;
    return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border: solid ", " ", ";\n  "], ["\n    border: solid ", " ", ";\n  "])), polished_1.rem(1), error ? theme.color.danger : theme.separatorColor);
}, polished_1.rem(14), polished_1.rem(10), function (_a) {
    var theme = _a.theme;
    return theme.textColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.form.placeholderColor;
}, function (props) {
    return props.readOnly && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background-color: transparent;\n      border-color: transparent;\n    "], ["\n      background-color: transparent;\n      border-color: transparent;\n    "])));
}, function (_a) {
    var theme = _a.theme;
    return theme.color.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.input.disabledTextColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.input.disabledBackground;
}, function (_a) {
    var theme = _a.theme;
    return theme.input.disabledCursor;
});
exports.default = (function (props) {
    var value = React.useContext(FormGroupContext_1.default);
    var inputRef = props.inputRef, readOnly = props.readOnly, id = props.id, className = props.className, resizable = props.resizable, _a = props.rows, rows = _a === void 0 ? 8 : _a, error = props.error, restProps = __rest(props, ["inputRef", "readOnly", "id", "className", "resizable", "rows", "error"]);
    return (React.createElement(Textarea, __assign({}, restProps, { className: className, ref: inputRef, readOnly: !!readOnly, id: id || value.id, resizable: resizable, rows: rows, error: error })));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
